<div id="upload-image-mobile" class="task-stats-mobile-dialog">

  <div class="mt-2">
    <kl-task-stats [statType]="dialogData?.data?.statType" [taskId]="dialogData?.data?.taskId"></kl-task-stats>
  </div>

</div>
